import { createContext, useContext } from 'react'

export const AnalyticsContext = createContext<{
  trackEvent: (event: string, value?: number) => Promise<void>
}>({
  trackEvent: () => Promise.resolve(),
})

export const useAnalyticsContext = () => useContext(AnalyticsContext)
